import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import axiosInstance from '../../utils/axiosConfig';
import { fetchCurrentUser } from '../../redux/slices/userSlice';

const ConfirmLinkModal = ({ isOpen, onClose, onSuccess, dataSelection, checkData, username, password }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const dispatch = useDispatch();

    if (!isOpen) return null;

    const telegramData = checkData?.telegramData || {};
    const webData = checkData?.webData || {};

    const getDataSummary = () => {
        const summary = [];

        if (dataSelection.subscription === 'telegram') {
            summary.push(`Подписка: Telegram (${telegramData.expireDate ? new Date(telegramData.expireDate).toLocaleDateString() : 'нет'})`);
            if (webData.expireDate) {
                summary.push(`⚠️ Подписка веб-аккаунта будет потеряна`);
            }
        } else {
            summary.push(`Подписка: Веб (${webData.expireDate ? new Date(webData.expireDate).toLocaleDateString() : 'нет'})`);
            if (telegramData.expireDate) {
                summary.push(`⚠️ Подписка Telegram аккаунта будет потеряна`);
            }
        }

        if (dataSelection.completedLessons === 'telegram') {
            summary.push(`Уроки: Telegram (${telegramData.completedLessonsCount || 0} уроков)`);
            if (webData.completedLessonsCount > 0) {
                summary.push(`⚠️ ${webData.completedLessonsCount} уроков веб-аккаунта будут потеряны`);
            }
        } else {
            summary.push(`Уроки: Веб (${webData.completedLessonsCount || 0} уроков)`);
            if (telegramData.completedLessonsCount > 0) {
                summary.push(`⚠️ ${telegramData.completedLessonsCount} уроков Telegram аккаунта будут потеряны`);
            }
        }

        if (dataSelection.profile === 'telegram') {
            summary.push(`Профиль: Telegram (${telegramData.profile?.name || 'Аноним'})`);
        } else {
            summary.push(`Профиль: Веб (${webData.profile?.name || 'Аноним'})`);
        }

        return summary;
    };

    const handleConfirm = async () => {
        setError('');
        setIsLoading(true);

        try {
            const initData = window.Telegram?.WebApp?.initData;
            if (!initData) {
                setError('Откройте профиль внутри Telegram для привязки аккаунта.');
                setIsLoading(false);
                return;
            }

            const response = await axiosInstance.post('/auth/link-web', {
                initData,
                username,
                password,
                dataSelection
            });

            if (response.data && response.data.success) {
                await dispatch(fetchCurrentUser());
                onSuccess();
            } else {
                setError(response.data?.error || 'Не удалось связать аккаунты');
            }
        } catch (err) {
            console.error('Link error:', err);
            setError(err.response?.data?.error || 'Ошибка при связывании аккаунтов');
        } finally {
            setIsLoading(false);
        }
    };

    const summary = getDataSummary();
    const hasWarnings = summary.some(item => item.includes('⚠️'));

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content modal-content-large" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>Подтверждение связывания</h2>
                    <button className="modal-close" onClick={onClose}>×</button>
                </div>
                <div className="modal-body">
                    <div className="warning-box">
                        <div className="warning-title">
                            <span>⚠️</span>
                            <strong>Внимание!</strong>
                        </div>
                        <p>
                            Некоторые данные могут быть безвозвратно утеряны при связывании аккаунтов.
                            Вы уверены, что хотите продолжить?
                        </p>
                    </div>

                    <div className="data-summary">
                        <h3>Выбранные данные:</h3>
                        <ul>
                            {summary.map((item, index) => (
                                <li
                                    key={index}
                                    className={item.includes('⚠️') ? 'warning' : ''}
                                >
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </div>

                    {error && (
                        <div className="error-message">
                            {error}
                        </div>
                    )}
                </div>
                <div className="modal-actions">
                    <div className="actions-group">
                        <button
                            type="button"
                            className="ghost-action"
                            onClick={onClose}
                            disabled={isLoading}
                        >
                            Нет, отменить
                        </button>
                        <button
                            type="button"
                            className={`primary-action ${hasWarnings ? 'warning' : ''}`}
                            onClick={handleConfirm}
                            disabled={isLoading}
                        >
                            {isLoading ? 'Связывание...' : 'Да, связать аккаунты'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmLinkModal;

